import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const CreateOrderPageContent = lazy(() => import("./CreateOrderPageContent"));

function CreateOrderPageInternal() {
    return (
        <DefaultPage>
            <CreateOrderPageContent />
        </DefaultPage>
    );
}

export const CreateOrderPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    CreateOrderPageInternal
);
